/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'format_color_reset': {
    width: 16,
    height: 16,
    viewBox: '0 0 15.86 17.93',
    data: '<path pid="0" d="M14 10.8C14 6.8 8 0 8 0a43.784 43.784 0 0 0-2.73 3.52l8.59 8.59A6.257 6.257 0 0 0 14 10.8zm-.88 3.12L8.5 9.3 1.27 2.07 0 3.35l3.32 3.32A9.553 9.553 0 0 0 2 10.8a6 6 0 0 0 6 6 5.98 5.98 0 0 0 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z" fill-rule="evenodd"/>'
  }
})
